import { i18n } from 'i18n';
import type {
  CellThreatDetailProps,
  CellThreatGroupProps,
} from '../../../threat.types';

export type DetectionDateHeaderProps = {
  text: string;
};

export const renderDetectionDateCell = (
  info: CellThreatGroupProps<string> | CellThreatDetailProps<string>,
) => {
  const date = info.getValue();
  if (!date) return '-';

  return i18n.format.date(date);
};
